<div class="d-flex flex-column justify-content-between h-100">
  <div
    *ngIf="[modalActions.ADD_CHURCH, modalActions.EDIT_CHURCH].includes(modalRequest.scope); else smallModalHeader"
    class="sticky-header d-flex justify-content-between align-items-center px-3 px-md-5 py-3 bg-gray"
  >
    <h1 class="mb-0">{{ churchDetails ? churchDetails.name : 'Add new church' }}</h1>
    <a (click)="close()"><i class="fas fa-2x fa-times gray-color pointer"></i></a>
  </div>
  <ng-template #smallModalHeader>
    <div class="d-flex justify-content-between">
      <h2 class="text-center w-100">{{ churchDetails ? 'Edit Church Details' : 'Add New Church' }}</h2>
      <a class="text-right width-fit font-20" (click)="close()"><i class="fas fa-times pointer"></i></a>
    </div>
  </ng-template>

  <mat-tab-group [selectedIndex]="selectedTabIndex" class="hide-tabs h-100">
    <mat-tab>
      <form [formGroup]="addChurchForm" [ngClass]="isSidePanel ? 'px-3 px-md-5 mt-3 mt-md-5' : ''">
        <div class="d-flex" class="flex-column">
          <!-- Church picture -->
          <div class="d-flex flex-column">
            <img
              class="profilePic"
              [defaultImage]="'https://fdi-files.s3.amazonaws.com/public/image-placeholder.png'"
              [lazyLoad]="churchPhoto?.path"
            />
            <a class="accent-color pointer mb-0 mt-1 text-nowrap width-fit" (click)="handleImageUpload()">
              <i class="fas fa-upload"></i> {{ (churchPhoto?.path ? 'DELETE' : 'UPLOAD') + ' CHURCH LOGO' }}
            </a>
            <mat-error
              *ngIf="(churchPictureUrl.invalid && (churchPictureUrl.dirty || churchPictureUrl.touched)) || (churchPictureUrl.invalid && submitted)"
              class="error"
            >
              <app-validation-message [control]="churchPictureUrl" [controlName]="'churchPictureUrl'"></app-validation-message>
            </mat-error>
          </div>
          <!-- Church Name-->
          <div class="admin-input w-100">
            <label for="churchName" class="label">Church name <span class="primary-color">*</span></label>
            <mat-form-field appearance="outline" class="w-100">
              <input id="churchName" matInput formControlName="churchName" maxlength="255" />
            </mat-form-field>
            <mat-error *ngIf="(churchName.invalid && (churchName.dirty || churchName.touched)) || (churchName.invalid && submitted)" class="error">
              <app-validation-message [control]="churchName" [controlName]="'churchName'"></app-validation-message>
            </mat-error>
          </div>
        </div>
        <!-- Headline -->
        <div class="admin-input">
          <label for="website" class="label">Headline</label>
          <mat-form-field appearance="outline" class="w-100">
            <input id="website" matInput formControlName="headline" maxlength="150" />
          </mat-form-field>
          <mat-error *ngIf="!!headline.value && headline.invalid && (headline.dirty || headline.touched)" class="error">
            <app-validation-message [control]="headline" [controlName]="'headline'"></app-validation-message>
          </mat-error>
        </div>

        <!--Description-->
        <div class="admin-textarea">
          <label for="description" class="label">Description</label>
          <mat-form-field appearance="outline" class="w-100">
            <textarea rows="4" id="description" matInput formControlName="description" maxlength="500"></textarea>
          </mat-form-field>
          <mat-error *ngIf="!!description.value && description.invalid && (description.dirty || description.touched)" class="error">
            <app-validation-message [control]="description" [controlName]="'description'"></app-validation-message>
          </mat-error>
        </div>

        <!-- Website -->
        <div class="admin-input">
          <label for="website" class="label">Website</label>
          <mat-form-field appearance="outline" class="w-100">
            <input id="website" matInput formControlName="website" maxlength="255" />
          </mat-form-field>
          <mat-error *ngIf="(website.invalid && (website.dirty || website.touched)) || (website.invalid && submitted)" class="error">
            <app-validation-message [control]="website" [controlName]="'website'"></app-validation-message>
          </mat-error>
        </div>

        <!-- Mainland -->
        <div class="admin-input">
          <label class="label mb-0 pb-0">Region & Location</label>
          <div class="font-12 mt-0">Start typing your country or state (if in the United States), <b>and select from the dropdown.</b></div>
          <mat-form-field appearance="outline">
            <input matInput formControlName="mainland" (focus)="liveSearchMainlandResults = []" [matAutocomplete]="auto" />
            <mat-autocomplete
              #auto="matAutocomplete"
              [displayWith]="displayFn"
              (optionSelected)="liveSearchMainlandResults = []"
              (closed)="liveSearchMainlandResults = []"
            >
              <mat-option *ngFor="let item of liveSearchMainlandResults" [value]="item"
                >{{ item.regionName }}, {{ item.subRegion }}, {{ item.name }}</mat-option
              >
            </mat-autocomplete>
          </mat-form-field>
          <mat-error *ngIf="(mainland.invalid && (mainland.dirty || mainland.touched)) || (mainland.invalid && submitted)" class="error">
            <app-validation-message [control]="mainland" [controlName]="'mainland'"></app-validation-message>
          </mat-error>
        </div>
        <!-- Visible -->
        <div class="d-flex justify-content-end admin-input" *ngIf="isSidePanel && isAdmin">
          <div class="d-flex flex-nowrap mt-2">
            <div
              class="label mr-2 mt-0 width-fit titlecase"
              [class.opacity-4]="churchDetails?.noOfGroups > 0"
              [class.disabled-text]="churchDetails?.noOfGroups > 0"
            >
              Invisible
            </div>
            <mat-slide-toggle
              formControlName="visible"
              color="primary"
              class="visible label mt-0 titlecase"
              [disabled]="churchDetails?.noOfGroups > 0"
              >Visible
            </mat-slide-toggle>
          </div>
        </div>
      </form>
    </mat-tab>
    <mat-tab>
      <div class="d-flex flex-column">
        <h3 class="mt-3 mb-5 text-center font-20">
          <ng-container *ngIf="churchDetails; else newChurch">
            Are you sure you want to make changes to the<br /><b>{{ churchName.value }}</b> details?<br />
            These changes may affect other groups affiliated with this church.
          </ng-container>
          <ng-template #newChurch>
            Review the details of <b>{{ churchName.value }}</b> before creating it.
          </ng-template>
        </h3>
        <h3 class="mb-3">This is how the new church details would look like:</h3>
        <div class="d-flex" [ngClass]="isSidePanel ? '' : 'flex-column'">
          <div class="mr-4 mr-xs-0">
            <img
              class="church-image"
              [defaultImage]="'https://fdi-files.s3.amazonaws.com/public/empty_profile_picture.svg'"
              [lazyLoad]="churchPictureUrl.value"
            />
          </div>
          <div>
            <h2 class="mt-2 mb-1 truncated-2-lines">{{ churchName.value }}</h2>
            <div class="smaller-text primary-color uppercase font-weight-bold mb-0">{{ headline.value }}</div>
            <div class="smaller-text mb-0">{{ description.value }}</div>
            <div class="my-2 pointer" *ngIf="website.value" (click)="navigate(website.value)">
              <i class="fas fa-link mr-2"></i> (link to {{ website.value }})
            </div>
          </div>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
  <div class="d-flex justify-content-between" [ngClass]="isSidePanel ? 'my-4 pb-4 px-3 px-md-5' : 'mt-4'">
    <ng-container *ngIf="isSidePanel; else smallModalButtons">
      <button mat-flat-button class="filter-button mr-2 uppercase" color="primary" (click)="close()">Cancel</button>
      <button mat-flat-button class="filter-button uppercase" color="accent" (click)="submit()">Save</button>
    </ng-container>
    <ng-template #smallModalButtons>
      <button mat-flat-button class="filter-button mr-2 uppercase" color="primary" (click)="smallModalBack()">
        {{ selectedTabIndex === 0 ? 'Cancel' : 'Back' }}
      </button>
      <button mat-flat-button class="filter-button uppercase" color="accent" (click)="smallModalSubmit()">
        {{ selectedTabIndex === 0 ? 'Review' : 'Save' }}
      </button>
    </ng-template>
  </div>
</div>
<div class="modal-loading-spinner" *ngIf="loading && isSidePanel">
  <app-loading-spinner [forceLoading]="loading"></app-loading-spinner>
</div>
